/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
/* eslint-disable import/prefer-default-export */
import { types, applySnapshot } from 'mobx-state-tree';

// ==================================================================
// Announcement
// ==================================================================
const Announcement = types
  .model('Announcement', {
    id: types.identifier,
    rev: types.maybe(types.number),
    type: '',
    content: '',
    color: '',
    status: '',
    priority: types.optional(types.number, 0),
    updatedAt: '',
    updatedBy: '',
    createdAt: '',
    createdBy: '',
  })
  .actions(self => ({
    setAnnouncement(raw) {
      applySnapshot(self, raw);
    },
  }))
  .views(self => ({
    get statusDisplay() {
      return self.status === 'active' ? 'Active' : 'Hidden';
    },
    get statusColor() {
      return self.status === 'active' ? 'green' : 'grey';
    },
  }));

export { Announcement };
